<template>
<ValidationObserver
    ref="labelStatementsLicensorPayments"
    v-slot="{ passes}"
>
    <BaseDialog
            :showDialog="showDialog"
            maxDialogWidth="750"
            maxCardHeight="800"
            headline="lang_LABEL_STATEMENTS_REPORT_LICENSOR_PAYMENTS" 
            :close="closeDialog"
            persistent
            :alvqa="alvqa"
        >
        
        <template v-slot:dialogText>
            <v-row>
                <!-- FROM MONTH -->
                <v-col>
                    <v-menu
                        ref="fromMonthMenu"
                        min-width="auto"
                        offset-y
                        :close-on-content-click="false"
                        :return-value.sync="fromValue"
                        v-model="fromMonthMenu"
                    > 
                        <template v-slot:activator="{ on }">
                            <ValidationProvider 
                                name="toMonth"
                                rules="required|labelStatementsCheckToFromMonthOrder"
                                v-slot="{ errors }"
                                slim
                            >
                                <v-text-field
                                    v-on="on"
                                    :value="getFormattedDateFrom"
                                    :label="$t('lang_LABEL_STATISTICS_CAPTION_FROM_MONTH')"
                                    @click:clear="resetFromValue()"
                                    readonly
                                    clearable
                                    :loading="loading"
                                    :alvqa="alvqa + '-textfield-from-month'"
                                    :error-messages="errors"
                                ></v-text-field>
                            </ValidationProvider>
                        </template>
                        <v-date-picker
                            v-model="fromValue"
                            :locale="$i18n.locale"
                            color="buttonStandard"
                            no-title
                            type="month"
                            :alvqa="alvqa + '-datepicker-from-month'"
                        >
                            <v-spacer></v-spacer>
                            <BaseButton 
                                class="text-center"
                                label="lang_GENERAL_BUTTON_CANCEL"
                                @click="fromMonthMenu = false"
                                :alvqa="alvqa + '-button-cancel'"
                            />
                            <BaseButton 
                                class="text-center"
                                label="lang_GENERAL_BUTTON_OK"
                                @click="$refs.fromMonthMenu.save(fromValue)"
                                :alvqa="alvqa + '-button-ok'"
                            />
                        </v-date-picker>
                    </v-menu> 
                </v-col>

                <!-- TO MONTH -->
                <v-col>
                    <v-menu
                        ref="toMonthMenu"
                        min-width="auto"
                        offset-y
                        :close-on-content-click="false"
                        :return-value.sync="toValue"
                        v-model="toMonthMenu"
                    > 
                        <template v-slot:activator="{ on }">
                            <ValidationProvider 
                                name="fromMonth"
                                rules="required|labelStatementsCheckToFromMonthOrder"
                                v-slot="{ errors }"
                                slim
                            >
                                <v-text-field
                                    v-on="on"
                                    :value="getFormattedDateTo"
                                    :label="$t('lang_LABEL_STATISTICS_CAPTION_TO_MONTH')"
                                    readonly
                                    @click:clear="resetToValue()"
                                    clearable
                                    :loading="loading"
                                    :alvqa="alvqa + '-textfield-to-month'"
                                    :error-messages="errors"
                                ></v-text-field>
                            </ValidationProvider>
                        </template>
                        <v-date-picker
                            v-model="toValue"
                            :locale="$i18n.locale"
                            color="buttonStandard"
                            no-title
                            type="month"
                            :alvqa="alvqa + '-datepicker-to-month'"
                        >
                            <v-spacer></v-spacer>
                            <BaseButton 
                                class="text-center"
                                label="lang_GENERAL_BUTTON_CANCEL"
                                @click="toMonthMenu = false"
                                :alvqa="alvqa + '-button-cancel'"
                            />
                            <BaseButton 
                                class="text-center"
                                label="lang_GENERAL_BUTTON_OK"
                                @click="$refs.toMonthMenu.save(toValue)"
                                :alvqa="alvqa + '-button-ok'"
                            />
                        </v-date-picker>
                    </v-menu>
                </v-col>
            </v-row>
        </template>

        <template v-slot:dialogActions>
            <v-container fluid >
                <v-row>
                    <v-spacer />
                    <v-col class="text-right">
                        <span v-if="reportLink" class="pr-3">
                            <a :href="reportLink" target="_blank">{{ $t('lang_GENERIC_CAPTION_CLICK_HERE_TO_DOWNLOAD') }}</a>
                        </span>
                        <span v-if="loading" class="pr-3">
                            <v-progress-circular 
                                size="16"
                                width="2"
                                color="dialogProgressbar"
                                indeterminate
                                :alvqa="alvqa + '-progress-bar-licensor-payments-report'" 
                            ></v-progress-circular>
                        </span>
                        <span>
                            <BaseButton 
                                label="lang_BUTTON_START"
                                @click="passes(start)"
                                :disabled="loading || allowReport === false"
                                :alvqa="alvqa+'-button-start'"
                            />
                        </span>
                    </v-col>
                </v-row>
            </v-container>
        </template>
    </BaseDialog>
</ValidationObserver>
</template>

<script>

import BaseDialog from '@/components/_base/BaseDialog'
import BaseButton from '@/components/_buttons/BaseButton'

export default{
    name: 'LabelStatementsPaymentsDialog',
    components: {
        BaseDialog,
        BaseButton
    },
    data() {
        return {
            alvqa: 'label-statements-licensor-payments-dialog',
            fromMonthMenu: false,
            toMonthMenu: false,
            licensorPaymentsReportProgress: false
        }
    },
    computed: {
        showDialog: {
            get() { return this.$store.getters.getShowLabelStatementsLicensorPaymentsDialog },
            set(show) { this.$store.commit('setShowLabelStatementsLicensorPaymentsDialog', show) }
        },
        fromValue: {
            get() { return this.$store.getters.getSelectedLabelStatementsLicensorPaymentsFromMonth },
            set(value) { this.$store.commit('setSelectedLabelStatementsLicensorPaymentsFromMonth', value) }
        },
        toValue: {
            get() { return this.$store.getters.getSelectedLabelStatementsLicensorPaymentsToMonth },
            set(value) { this.$store.commit('setSelectedLabelStatementsLicensorPaymentsToMonth', value) }
        },
        reportLink: {
            get() { return this.$store.getters.getLabelStatementsLicensorPaymentsReportLink },
            set(value) { this.$store.commit('setLabelStatementsLicensorPaymentsReportLink', value) }
        },
        getFormattedDateFrom() { return this.fromValue ? this.$d(new Date(this.fromValue), 'alvMonthYearFormat') : '' },
        getFormattedDateTo() { return this.toValue ? this.$d(new Date(this.toValue), 'alvMonthYearFormat') : '' },
        loading: {
            get() { return this.$store.getters.getIsLoading },
            set(value) { this.$store.commit('setIsLoading', value) }
        }, 
        allowReport() {
            return this.$store.getters.getLabelStatementsLicensorPaymentsAllowReport
        }
    },
    methods: {
        closeDialog() {
            this.showDialog = false
            this.$store.commit('setSelectedLabelStatementsAction', [])
            this.reportLink = null
            this.resetFromValue()
            this.resetToValue()
        },
        resetFromValue(){
            this.$store.commit("setSelectedLabelStatementsLicensorPaymentsFromMonth",null)
        },
        resetToValue(){
            this.$store.commit("setSelectedLabelStatementsLicensorPaymentsToMonth",null)
        },
        start(){
            this.$store.dispatch('createLabelStatementsLicensorPaymentsReport')
        }
    }
}
</script>

<style>

</style>